'use client'

import { Box } from '@chakra-ui/react'
import { usePathname } from 'next/navigation'

import { SearchForProducts } from 'components/form/SearchForProducts'

const SearchBar = (): JSX.Element | null => {
  const pathname = usePathname()

  if (pathname === '/') {
    return null
  }

  return (
    <Box width="70%" marginLeft="auto" marginRight="auto" display={{ base: 'none', md: 'block' }}>
      <SearchForProducts redirectTo={pathname?.includes('/bundles') ? 'bundles' : 'browse'} />
    </Box>
  )
}

export default SearchBar
